// Subscription Add to Cart
// Vitals You May Also Like + Vitals Wishlist
(function () {
  'use strict';

  const VITALS_BUTTON_SELECTOR =
    '.vtl-product-card__atc-button[data-custom-subscription-atc="true"]';

  const WISHLIST_BUTTON_SELECTOR =
    '.Vtl-WishlistProduct__SubscriptionATC[data-custom-subscription-atc="true"]';


  /* ---------------------------------------
     SPINNER CSS
  --------------------------------------- */

  if (!document.getElementById('subscription-atc-spinner-css')) {

    const style = document.createElement('style');

    style.id = 'subscription-atc-spinner-css';

    style.textContent = `
      .subscription-atc-loading {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        pointer-events: none !important;
      }

      .subscription-atc-spinner {
        width: 17px;
        height: 17px;
        border: 2px solid rgba(255,255,255,.45);
        border-top-color: #fff;
        border-radius: 50%;
        display: inline-block;
        animation: subscriptionAtcSpin .7s linear infinite;
      }

      @keyframes subscriptionAtcSpin {
        to {
          transform: rotate(360deg);
        }
      }

      .Vtl-WishlistProduct__SubscriptionATC {
        width: 100%;
        margin-top: 12px;
        padding: 10px 14px;
        border: 2px solid rgb(88, 125, 104);
        background: rgb(88, 125, 104);
        color: #fff;
        font-family: Palatino, "Palatino Linotype", "Book Antiqua", serif;
        cursor: pointer;
      }

      .Vtl-WishlistProduct__SubscriptionATC.subscription-atc-loading {
        cursor: default;
      }
    `;

    document.head.appendChild(style);
  }


  /* ---------------------------------------
     GET PRODUCT JSON
  --------------------------------------- */

  /*
   * Cache so each product is fetched only once
   */
  const productCache = new Map();

  function getProduct(handle) {

    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetchProduct(handle).then(product => {
          if (!product) productCache.delete(handle);
          return product;
        })
      );
    }

    return productCache.get(handle);
  }


  async function fetchProduct(handle) {

    try {

      const response =
        await fetch(
          `/products/${encodeURIComponent(handle)}.js`
        );

      if (!response.ok) {
        return null;
      }

      return await response.json();

    } catch (error) {

      console.error(
        '[Subscription ATC] Product fetch error:',
        error
      );

      return null;
    }
  }


  /* ---------------------------------------
     GET APPSTLE PLAN
  --------------------------------------- */

  function getAppstleSubscription(product) {

    if (!product) return null;

    const group =
      (product.selling_plan_groups || []).find(
        group =>
          group.app_id === 'appstle'
      );

    if (
      !group ||
      !group.selling_plans ||
      !group.selling_plans.length
    ) {
      return null;
    }

    return {
      group: group,
      plan: group.selling_plans[0]
    };
  }


  /* ---------------------------------------
     VITALS PRODUCT CARDS
  --------------------------------------- */

  async function setupVitalsCard(card) {

    if (!card) return;

    const details =
      card.querySelector(
        '.vtl-product-card__details'
      );

    const handleEl =
      card.querySelector(
        '[data-vitals-product-handle]'
      );

    if (!details || !handleEl) return;

    /*
     * Already checked (normal or subscription)
     */
    if (
      card.dataset.subscriptionChecked === 'true'
    ) {
      return;
    }

    /*
     * Already has our button
     */
    if (
      details.querySelector(
        '[data-custom-subscription-atc="true"]'
      )
    ) {
      return;
    }

    /*
     * Prevent duplicate requests
     */
    if (
      card.dataset.subscriptionChecking === 'true'
    ) {
      return;
    }

    card.dataset.subscriptionChecking = 'true';

    const handle =
      handleEl.getAttribute(
        'data-vitals-product-handle'
      );

    if (!handle) {
      delete card.dataset.subscriptionChecking;
      return;
    }

    try {

      const product =
        await getProduct(handle);

      if (product) {
        card.dataset.subscriptionChecked = 'true';
      }

      const subscription =
        getAppstleSubscription(product);

      /*
       * Normal product - do nothing
       */
      if (!subscription) {

        delete card.dataset.subscriptionChecking;

        return;
      }

      /*
       * First available variant
       */
      const variant =
        (product.variants || []).find(
          variant => variant.available
        );

      if (!variant) {

        delete card.dataset.subscriptionChecking;

        return;
      }

      /*
       * Add with one-time purchase price.
       * Only subscription-only products need a plan.
       */
      createVitalsButton(
        details,
        variant.id,
        product.requires_selling_plan
          ? subscription.plan.id
          : ''
      );

      delete card.dataset.subscriptionChecking;

    } catch (error) {

      console.error(
        '[Subscription ATC] Vitals error:',
        error
      );

      delete card.dataset.subscriptionChecking;
    }
  }


  function createVitalsButton(
    details,
    variantId,
    sellingPlanId
  ) {

    if (
      details.querySelector(
        '[data-custom-subscription-atc="true"]'
      )
    ) {
      return;
    }

    const button =
      document.createElement('button');

    button.type = 'button';

    button.className =
      'vtl-product-card__atc-button';

    button.setAttribute(
      'data-custom-subscription-atc',
      'true'
    );

    button.dataset.variantId =
      variantId;

    button.dataset.sellingPlanId =
      sellingPlanId;

    button.textContent =
      'Add to Cart';

    /*
     * Existing Vitals style
     */
    button.style.border =
      '3px solid rgb(88, 125, 104)';

    button.style.backgroundColor =
      'rgb(88, 125, 104)';

    button.style.color =
      'rgb(255, 255, 255)';

    button.style.fontFamily =
      'Palatino, "Palatino Linotype", "Book Antiqua", serif';

    button.style.boxShadow =
      'rgb(168, 232, 226) 0px 0px 0px 0px';

    details.appendChild(button);
  }


  /* ---------------------------------------
     WISHLIST PRODUCT CARDS
     --------------------------------------- */

  async function setupWishlistProduct(card) {

    if (!card) return;

    /*
     * Don't add duplicate button
     */
    if (
      card.querySelector(
        WISHLIST_BUTTON_SELECTOR
      )
    ) {
      return;
    }

    /*
     * Find product link
     */
    const productLink =
      card.querySelector(
        '.Vtl-WishlistProduct__Link[href*="/products/"]'
      );

    if (!productLink) return;

    /*
     * Already checked (normal or subscription)
     */
    if (
      card.dataset.subscriptionChecked === 'true'
    ) {
      return;
    }

    /*
     * Prevent duplicate checking
     */
    if (
      card.dataset.subscriptionChecking === 'true'
    ) {
      return;
    }

    card.dataset.subscriptionChecking = 'true';


    try {

      const href =
        productLink.getAttribute('href');

      if (!href) {
        delete card.dataset.subscriptionChecking;
        return;
      }


      /*
       * Extract product handle
       *
       * /products/pearl-roll-on-oil?variant=...
       *
       * becomes:
       *
       * pearl-roll-on-oil
       */
      const match =
        href.match(
          /\/products\/([^/?#]+)/
        );

      if (!match) {
        delete card.dataset.subscriptionChecking;
        return;
      }

      const handle =
        match[1];


      /*
       * Product JSON
       */
      const product =
        await getProduct(handle);

      if (product) {
        card.dataset.subscriptionChecked = 'true';
      }


      /*
       * Check Appstle
       */
      const subscription =
        getAppstleSubscription(product);


      /*
       * Normal product:
       * don't add anything.
       */
      if (!subscription) {

        delete card.dataset.subscriptionChecking;

        return;
      }


      /*
       * Use wishlist URL variant if available
       */
      const url =
        new URL(
          href,
          window.location.origin
        );

      const urlVariant =
        Number(
          url.searchParams.get('variant')
        );


      /*
       * First use wishlist-selected variant
       * if it exists.
       *
       * Otherwise use first available variant.
       */
      let variant =
        (product.variants || []).find(
          item =>
            item.id === urlVariant &&
            item.available
        );


      if (!variant) {

        variant =
          (product.variants || []).find(
            item => item.available
          );

      }


      if (!variant) {

        delete card.dataset.subscriptionChecking;

        return;
      }


      /*
       * Create wishlist ATC
       */
      createWishlistButton(
        card,
        variant.id,
        product.requires_selling_plan
          ? subscription.plan.id
          : ''
      );


    


      delete card.dataset.subscriptionChecking;

    } catch (error) {

      console.error(
        '[Subscription ATC] Wishlist error:',
        error
      );

      delete card.dataset.subscriptionChecking;
    }
  }


  function createWishlistButton(
    card,
    variantId,
    sellingPlanId
  ) {

    if (
      card.querySelector(
        WISHLIST_BUTTON_SELECTOR
      )
    ) {
      return;
    }


    const button =
      document.createElement('button');

    button.type = 'button';

    button.className =
      'Vtl-WishlistProduct__SubscriptionATC';

    button.setAttribute(
      'data-custom-subscription-atc',
      'true'
    );

    button.dataset.variantId =
      variantId;

    button.dataset.sellingPlanId =
      sellingPlanId;

    button.textContent =
      'Add to Cart';


    /*
     * Put button AFTER product link
     */
    card.appendChild(button);
  }


  /* ---------------------------------------
     SCAN BOTH
  --------------------------------------- */

  function scanAllProducts() {

    /*
     * Vitals You May Also Like
     */
    document
      .querySelectorAll(
        '.vtl-product-card'
      )
      .forEach(
        setupVitalsCard
      );


    /*
     * Vitals Wishlist
     */
    document
      .querySelectorAll(
        '.Vtl-WishlistProduct'
      )
      .forEach(
        setupWishlistProduct
      );
  }


  /* ---------------------------------------
     SPINNER
  --------------------------------------- */

  function showSpinner(button) {

    button.dataset.loading =
      'true';

    /*
     * Lock size so the card doesn't jump
     */
    const rect =
      button.getBoundingClientRect();

    button.style.width =
      rect.width + 'px';

    button.style.height =
      rect.height + 'px';

    button.disabled =
      true;

    button.classList.add(
      'subscription-atc-loading'
    );

    button.innerHTML =
      '<span class="subscription-atc-spinner" aria-hidden="true"></span>';
  }


  function hideSpinner(button) {

    button.dataset.loading =
      'false';

    button.disabled =
      false;

    button.classList.remove(
      'subscription-atc-loading'
    );

    button.textContent =
      'Add to Cart';

    button.style.width = '';
    button.style.height = '';
  }


  /* ---------------------------------------
     OPEN CART DRAWER
  --------------------------------------- */

  function openCartDrawer(result) {

    /*
     * Vitals app cart drawer (same drawer as
     * Vitals' own Add to Cart). It reloads
     * /cart.js itself when it opens.
     */
    if (
      window.vtlsCartDrawer &&
      typeof window.vtlsCartDrawer.show ===
      'function'
    ) {

      try {

        window.vtlsCartDrawer.show();

        return true;

      } catch (error) {

        console.warn(
          '[Subscription ATC] Vitals drawer error:',
          error
        );
      }
    }


    /*
     * Fallback: theme mini cart (assets/cart-drawer.js)
     * renderContents() swaps the drawer HTML
     * and opens it - same as product form.
     */
    const miniCart =
      document.querySelector(
        'mini-cart'
      );


    if (
      miniCart &&
      result &&
      result.sections &&
      typeof miniCart.renderContents ===
      'function'
    ) {

      try {

        miniCart.classList.remove(
          'is-empty'
        );

        miniCart.renderContents(
          result
        );

        return true;

      } catch (error) {

        console.warn(
          '[Subscription ATC] Drawer error:',
          error
        );
      }
    }


    /*
     * Fallback: theme cart-drawer refresh + open
     */
    if (
      document.querySelector(
        'cart-drawer'
      )
    ) {

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            bubbles: true,
            detail: {
              open: true
            }
          }
        )
      );

      return true;
    }


    /*
     * No drawer - go to cart page
     */
    window.location.href =
      '/cart';

    return false;
  }


  /* ---------------------------------------
     ADD PRODUCT TO CART
     (one-time purchase price)
  --------------------------------------- */

  async function addSubscriptionToCart(
    button
  ) {

    if (
      button.dataset.loading ===
      'true'
    ) {
      return;
    }


    const variantId =
      Number(
        button.dataset.variantId
      );

    /*
     * Only set for subscription-only products
     */
    const sellingPlanId =
      Number(
        button.dataset.sellingPlanId
      );


    if (!variantId) {

      console.error(
        '[Subscription ATC] Missing variant'
      );

      return;
    }


    showSpinner(button);


    try {

      const item = {
        id: variantId,
        quantity: 1
      };

      if (sellingPlanId) {
        item.selling_plan =
          sellingPlanId;
      }


      /*
       * Ask Shopify for the mini cart sections
       * in the same request
       */
      const miniCart =
        document.querySelector(
          'mini-cart'
        );

      const body = {
        items: [item]
      };

      if (
        miniCart &&
        typeof miniCart.getSectionsToRender ===
        'function'
      ) {

        body.sections =
          miniCart
            .getSectionsToRender()
            .map(
              section =>
                section.section
            );

        body.sections_url =
          window.location.pathname;
      }


      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            body:
              JSON.stringify(body)
          }
        );


      const result =
        await response.json();


      if (!response.ok) {

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add product'
        );
      }

      /*
       * Let theme components (free shipping bar etc.) know
       */
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {

        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'subscription-atc',
            productVariantId: variantId,
            cart: result
          }
        );
      }


      /*
       * Refresh + open drawer
       */
      openCartDrawer(
        result
      );


      /*
       * Restore button
       */
      setTimeout(
        function () {

          hideSpinner(button);

        },
        700
      );


    } catch (error) {

      console.error(
        '[Subscription ATC] Add to cart error:',
        error
      );

      hideSpinner(button);
    }
  }


  /* ---------------------------------------
     BUTTON CLICK
  --------------------------------------- */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          `${VITALS_BUTTON_SELECTOR}, ${WISHLIST_BUTTON_SELECTOR}`
        );


      if (!button) {
        return;
      }


      /*
       * Our custom buttons only
       */
      event.preventDefault();
      event.stopImmediatePropagation();


      addSubscriptionToCart(
        button
      );

    },
    true
  );


  /* ---------------------------------------
     INITIAL SCAN
  --------------------------------------- */

  function init() {

    scanAllProducts();
  }    
  /* ---------------------------------------
     VITALS MUTATION OBSERVER
  --------------------------------------- */

  let scanTimer = null;

  function isIgnoredMutation(mutation) {

    const target =
      mutation.target;

    if (
      !target ||
      typeof target.closest !== 'function'
    ) {
      return false;
    }

    /*
     * Cart drawer updates + our own spinner
     */
    return !!target.closest(
      'cart-drawer, mini-cart, [data-custom-subscription-atc="true"]'
    );
  }

  const observer =
    new MutationObserver(
      function (mutations) {

        if (
          mutations.every(
            isIgnoredMutation
          )
        ) {
          return;
        }

        /*
         * Debounce - run once after changes settle
         */
        clearTimeout(scanTimer);

        scanTimer =
          setTimeout(
            scanAllProducts,
            150
          );

      }
    );


  if (document.body) {

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  } else {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        observer.observe(
          document.body,
          {
            childList: true,
            subtree: true
          }
        );

      }
    );
  }


  /* ---------------------------------------
     EXTRA VITALS/WISHLIST CHECK
  --------------------------------------- */

  let attempts = 0;

  const interval =
    setInterval(
      function () {

        scanAllProducts();

        attempts++;

        if (attempts >= 15) {

          clearInterval(
            interval
          );
        }

      },
      2000
    );

})();


// For cart drawer adding bundles product



(function () {
  'use strict';

  var VISIBLE_DRAWER =
    '.Vtl-CartDrawer__Container--IsVisible';

  var EMPTY_CLASS =
    'Vtl-CartDrawer__Container--Empty';

  var BUNDLE_ROOT = '#bundle-product-bundles';
  var WIDGET = '.vtl-ub-pb-main-widget';
  var OLD_WRAPPER = '#sage-cart-bundle-wrapper';
  var SLOT_ID = 'sage-cart-bundle-slot';

  // Non-product pages: the bundle offer is loaded from the Vitals API
  // and rendered in the drawer slot (see "bundle built in the drawer").
  var PAGE_BUNDLE_BLOCK = '[id*="vitals_ub_product_bundles"]';
  var STORE_KEY = 'sageCartBundle';
  var STOREFRONT_API_VERSION = '2026-07';
  var VITALS_OPTION_LIMIT = 25;
  var COLLECTION_QUERY =
    'query SageBundleCollection($id: ID!, $first: Int!) { node(id: $id) { ' +
    '... on Collection { products(first: $first) { nodes { id } } } } }';
  var PRODUCTS_QUERY =
    'query SageBundleProducts($ids: [ID!]!, $country: CountryCode, $language: LanguageCode) ' +
    '@inContext(country: $country, language: $language) { nodes(ids: $ids) { ... on Product { ' +
    'id title handle availableForSale featuredImage { url } ' +
    'variants(first: 50) { nodes { id title availableForSale price { amount } } } } } }';

  var bundleNode = null;
  var placeholder = null;
  var originalParent = null;
  var observer = null;
  var updating = false;

  var usePageWidget = false;
  // Product pages: true when the last add was another product (e.g. from
  // "You May Also Like"), so its bundle is built instead of moving the
  // page's own Vitals widget.
  var pageProductId = null;
  var showOtherBundle = false;
  var drawerOpen = false;
  var cartSynced = false;
  var cartItem = null;
  var cartSnapshot = null;
  var syncTimer = null;
  var syncIgnoreNew = true;
  var ownAddUntil = 0;
  var bundleCache = {};
  var selection = null;
  var pickerListenersBound = false;

  function findWidget() {
    return (
      document.querySelector(OLD_WRAPPER + ' ' + WIDGET) ||
      document.querySelector(BUNDLE_ROOT + ' ' + WIDGET)
    );
  }

  function findBundleNode(widget) {
    var root = document.querySelector(BUNDLE_ROOT);

    return root && root.contains(widget) ? root : widget;
  }

  function prepareBundle() {
    var widget = findWidget();

    if (!widget) return false;

    var root = document.querySelector(BUNDLE_ROOT);

    if (root && !root.contains(widget)) {
      root.appendChild(widget);
    }

    bundleNode = findBundleNode(widget);

    if (!placeholder || !placeholder.parentNode) {
      originalParent = bundleNode.parentNode;

      if (!originalParent) return false;

      placeholder = document.createComment(
        'Original Vitals bundle position'
      );

      originalParent.insertBefore(placeholder, bundleNode);
    }

    var oldWrapper = document.querySelector(OLD_WRAPPER);

    if (
      oldWrapper &&
      !oldWrapper.contains(bundleNode) &&
      !oldWrapper.querySelector(WIDGET)
    ) {
      oldWrapper.remove();
    }

    return true;
  }

  function getDrawerSlot(drawer) {
    var slot = drawer.querySelector('#' + SLOT_ID);

    if (slot) return slot;

    var bottom = drawer.querySelector(
      '.Vtl-CartDrawer__Container-Content-BottomContainer'
    );

    if (!bottom) {
      bottom = drawer.querySelector(
        '.Vtl-CartDrawer__Container-Content'
      );
    }

    if (!bottom) return null;

    slot = document.createElement('div');
    slot.id = SLOT_ID;
    slot.className = 'sage-cart-bundle-slot';

    var upsell = bottom.querySelector(
      '.Vtl-CartDrawerUpsellSuggestionsProducts'
    );

    if (upsell) {
      bottom.insertBefore(slot, upsell);
    } else {
      bottom.insertBefore(slot, bottom.firstChild);
    }

    return slot;
  }

  function restoreBundle() {
    if (!bundleNode) return;

    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(
        bundleNode,
        placeholder
      );

      placeholder.remove();
      placeholder = null;
      originalParent = null;
      return;
    }

    if (originalParent && originalParent.isConnected) {
      originalParent.appendChild(bundleNode);
      originalParent = null;
      return;
    }

    var root = document.querySelector(BUNDLE_ROOT);

    if (root && root !== bundleNode && !root.contains(bundleNode)) {
      root.appendChild(bundleNode);
    }
  }

  function isDrawerEmpty(drawer, cartContent) {
    var isEmpty = drawer.classList.contains(EMPTY_CLASS);

    if (!isEmpty) {
      var contentText = cartContent.innerText || '';

      var hasEmptyMessage =
        contentText.includes('Not sure where to start? Try a sample') ||
        contentText.includes('Continue shopping');

      var cartItems = drawer.querySelectorAll(
        '.Vtl-CartDrawer__Container-Content [class*="CartItem"], ' +
        '.Vtl-CartDrawer__Container-Content [class*="CartProduct"], ' +
        '.Vtl-CartDrawer__Container-Content [class*="CartLine"]'
      );

      var hasProductRows = Array.prototype.some.call(
        cartItems,
        function (item) {
          return item.querySelector('img') &&
            item.getClientRects().length > 0;
        }
      );

      var quantityInputs = drawer.querySelectorAll(
        'input[name="updates[]"], input[name="quantity"]'
      );

      var hasQuantity = Array.prototype.some.call(
        quantityInputs,
        function (input) {
          return Number(input.value) > 0;
        }
      );

      isEmpty =
        hasEmptyMessage &&
        !hasProductRows &&
        !hasQuantity;
    }

    return isEmpty;
  }

  function getPageProductId() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;

    if (meta && meta.product && meta.product.id) {
      return Number(meta.product.id);
    }

    var input = document.querySelector(
      'product-info input[name="product-id"], form[id^="product-form-"] input[name="product-id"]'
    );

    return input ? Number(input.value) : null;
  }

  // Removes a bundle built for another product before the page's own
  // Vitals widget is moved back into the slot.
  function clearBuiltBundle(drawer) {
    var slot = drawer.querySelector('#' + SLOT_ID);

    if (slot && slot.hasAttribute('data-bundle-key')) {
      slot.removeAttribute('data-bundle-key');
      slot.innerHTML = '';
    }
  }

  function hideSlot(drawer) {
    var slot = drawer.querySelector('#' + SLOT_ID);

    if (slot) {
      slot.style.display = 'none';
    }
  }

  function moveBundleIntoDrawer(drawer) {
    var cartContent = drawer.querySelector(
      '.Vtl-CartDrawer__Container-Content'
    );

    if (!cartContent) return;

    if (isDrawerEmpty(drawer, cartContent)) {
      hideSlot(drawer);

      // Restore the original widget to protect the PDP layout.
      restoreBundle();
      return;
    }

    if (!prepareBundle()) return;

    var slot = getDrawerSlot(drawer);

    if (!slot || !bundleNode) return;

    slot.style.display = '';

    if (!slot.contains(bundleNode)) {
      slot.appendChild(bundleNode);
    }
  }

  /* ---------- Non-product pages: bundle built in the drawer ---------- */

  // Vitals only renders its bundle widget on product pages, so here the
  // same offer is loaded from the Vitals API and rendered by us. The
  // add-to-cart payload matches the Vitals widget (_oid + parent_id),
  // which is what the Vitals discount function keys on.

  function readStore() {
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORE_KEY));

      if (stored) {
        cartItem = stored.item || null;
        cartSnapshot = stored.cart || null;
      }
    } catch (e) {}
  }

  function writeStore() {
    try {
      sessionStorage.setItem(
        STORE_KEY,
        JSON.stringify({ item: cartItem, cart: cartSnapshot })
      );
    } catch (e) {}
  }

  function toCartItem(item) {
    return {
      productId: item.product_id,
      variantId: item.variant_id
    };
  }

  // Picks the product whose bundle is shown: the item that was
  // just added (or increased), otherwise the newest cart item.
  function syncCart(ignoreNew) {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var snapshot = {};
        var added = null;
        var addedPageProduct = false;
        var stillInCart = false;

        items.forEach(function (item) {
          snapshot[item.key] = item.quantity;

          if (cartItem && item.product_id === cartItem.productId) {
            stillInCart = true;
          }

          if (
            !ignoreNew &&
            cartSnapshot &&
            item.quantity > (cartSnapshot[item.key] || 0)
          ) {
            if (!added) added = item;
            if (item.product_id === pageProductId) addedPageProduct = true;
          }
        });

        if (usePageWidget && added) {
          showOtherBundle = !addedPageProduct;
        }

        if (added) {
          cartItem = toCartItem(added);
        } else if (!cartItem || !stillInCart) {
          cartItem = items.length ? toCartItem(items[0]) : null;
        }

        cartSnapshot = snapshot;
        cartSynced = true;
        writeStore();
        update();
      })
      .catch(function () {});
  }

  function scheduleCartSync(ignoreNew) {
    syncIgnoreNew = syncIgnoreNew && ignoreNew;
    clearTimeout(syncTimer);

    syncTimer = setTimeout(function () {
      var ignore = syncIgnoreNew;
      syncIgnoreNew = true;
      syncCart(ignore);
    }, 300);
  }

  function refreshVitalsDrawer() {
    var cartDrawer = window.vtlsCartDrawer;

    document.dispatchEvent(
      new CustomEvent('vitals:cart-drawer:syncRequested')
    );

    if (
      cartDrawer &&
      typeof cartDrawer.isOpen === 'function' &&
      typeof cartDrawer.show === 'function' &&
      cartDrawer.isOpen()
    ) {
      cartDrawer.show();
    }
  }

  function numericId(gid) {
    return Number(String(gid).split('/').pop());
  }

  function bundleUrl(productId) {
    var data = window.vtlsLiquidData || {};
    var shop = data.shopInfo && data.shopInfo.id;

    if (!shop) return null;

    var host = (data.apiHosts && data.apiHosts['1']) || 'https://appsolve.io';
    var cacheKey = (data.cacheKeys && data.cacheKeys[3]) || 0;
    var shopify = window.Shopify || {};

    return host + '/bundle/api/v2/sf/ub/pp/' + shop + '/' +
      (shopify.locale || 'en') + '/' + cacheKey + '/' +
      (shopify.country || 'US') + '/' + productId + '.json';
  }

  function fetchProducts(ids) {
    var shopify = window.Shopify || {};

    return fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        query: PRODUCTS_QUERY,
        variables: {
          ids: ids.map(function (id) {
            return 'gid://shopify/Product/' + id;
          }),
          country: shopify.country || 'US',
          language: String(shopify.locale || 'en').split('-')[0].toUpperCase()
        }
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var products = {};

        ((json.data && json.data.nodes) || []).forEach(function (node) {
          if (!node || !node.availableForSale) return;

          var variants = node.variants.nodes
            .filter(function (variant) {
              return variant.availableForSale;
            })
            .map(function (variant) {
              return {
                id: numericId(variant.id),
                title: variant.title,
                price: Number(variant.price.amount)
              };
            });

          if (!variants.length) return;

          products[numericId(node.id)] = {
            id: numericId(node.id),
            title: node.title,
            handle: node.handle,
            image: node.featuredImage && node.featuredImage.url,
            variants: variants
          };
        });

        return products;
      });
  }

  // Second-product candidates, same as the Vitals widget: the first 25
  // products listed on the offer (including the added product itself,
  // e.g. Pearl + Pearl), or, for offers built from collections such as
  // "1/2oz & Extract", the products of the offer's first collection.
  function groupProductIds(group) {
    if (group.products && group.products.length) {
      return Promise.resolve(
        group.products.slice(0, VITALS_OPTION_LIMIT).map(function (product) {
          return product.id;
        })
      );
    }

    if (!group.collections || !group.collections.length) return Promise.resolve([]);

    return fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        query: COLLECTION_QUERY,
        variables: {
          id: 'gid://shopify/Collection/' + group.collections[0],
          first: VITALS_OPTION_LIMIT
        }
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var collection = json.data && json.data.node;

        return collection
          ? collection.products.nodes.map(function (node) {
            return numericId(node.id);
          })
          : [];
      });
  }

  // An offer is the added product plus one or more groups to pick from
  // (one group for "Buy 2", four for the sample vial "Discovery Set").
  function loadBundle(productId) {
    if (bundleCache[productId]) return bundleCache[productId];

    var url = bundleUrl(productId);

    if (!url) return Promise.resolve(null);

    bundleCache[productId] = fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (json) {
        var offer = json && json.productBundle;

        if (!offer || !offer.items || offer.items.length < 2) return null;

        var main = offer.items[0].products[0];

        if (!main) return null;

        return Promise.all(offer.items.slice(1).map(groupProductIds)).then(function (groupIds) {
          var ids = [main.id];

          groupIds.forEach(function (list) {
            list.forEach(function (id) {
              if (ids.indexOf(id) === -1) ids.push(id);
            });
          });

          return fetchProducts(ids).then(function (products) {
            var settings = offer.bundle;
            var canChange = settings.allowChangingBundleByGroup || [];
            var groups = groupIds.map(function (list, index) {
              return {
                canChange: canChange[index + 1] !== false,
                // Vitals shows the candidates in a new random order on every load.
                options: shuffle(
                  list
                    .map(function (id) {
                      return products[id];
                    })
                    .filter(Boolean)
                )
              };
            });

            var complete = groups.every(function (group) {
              return group.options.length;
            });

            if (!products[main.id] || !complete) return null;

            return {
              id: settings.id,
              title: settings.title,
              buttonText: settings.productPageButtonText || 'Add bundle to cart',
              discountType: settings.discountType,
              discountAmount: Number(settings.discountAmount) || 0,
              main: products[main.id],
              mainPrefVariant: main.prefVariant,
              groups: groups
            };
          });
        });
      })
      .catch(function () {
        delete bundleCache[productId];
        return null;
      });

    return bundleCache[productId];
  }

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var item = list[i];

      list[i] = list[j];
      list[j] = item;
    }

    return list;
  }

  function findVariant(product, variantId) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === variantId) return product.variants[i];
    }

    return product.variants[0];
  }

  function findOption(group, productId) {
    for (var i = 0; i < group.options.length; i++) {
      if (group.options[i].id === productId) return group.options[i];
    }

    return group.options[0];
  }

  // Selection for the bundle currently shown; reset when the product changes.
  // picks[0] is the added product, picks[1..] one per group. Like the Vitals
  // widget the defaults are random, and different from each other if possible.
  function getSelection(bundle) {
    if (!selection || selection.productId !== bundle.main.id) {
      var used = [];
      var picks = [{
        product: bundle.main.id,
        variant: findVariant(
          bundle.main,
          cartItem && cartItem.variantId || bundle.mainPrefVariant
        ).id
      }];

      bundle.groups.forEach(function (group) {
        var start = Math.floor(Math.random() * group.options.length);
        var pick = group.options[start];

        for (var i = 0; i < group.options.length; i++) {
          var option = group.options[(start + i) % group.options.length];

          if (used.indexOf(option.id) === -1) {
            pick = option;
            break;
          }
        }

        used.push(pick.id);
        picks.push({ product: pick.id, variant: pick.variants[0].id });
      });

      selection = {
        productId: bundle.main.id,
        picks: picks,
        // "See more" checkboxes, one per item. Unticking any of them
        // drops the bundle discount, as in the Vitals widget.
        checked: picks.map(function () {
          return true;
        }),
        detailsOpen: false
      };
    }

    return selection;
  }

  // The products and variants currently in the bundle, in display order.
  function bundleEntries(bundle, state) {
    return state.picks.map(function (pick, index) {
      var product = index === 0
        ? bundle.main
        : findOption(bundle.groups[index - 1], pick.product);

      return { product: product, variant: findVariant(product, pick.variant) };
    });
  }

  function isFullBundle(state) {
    return state.checked.every(Boolean);
  }

  function itemSalePrice(bundle, price) {
    return bundle.discountType === 'percent'
      ? price * (1 - bundle.discountAmount / 100)
      : price;
  }

  function formatMoney(amount) {
    var data = window.vtlsLiquidData || {};
    var format = (data.shopInfo && data.shopInfo.moneyFormat) || '$ {{amount}}';
    var fixed = (Math.round(amount * 100) / 100).toFixed(2);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, type) {
      if (type === 'amount_no_decimals') return whole;
      if (type === 'amount_with_comma_separator') {
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      }
      return whole + '.' + parts[1];
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function imageUrl(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=300';
  }

  function variantSelect(product, selectedId, index) {
    if (product.variants.length < 2) return '';

    return '<select class="sage-bundle__select" data-role="variant" data-index="' + index +
      '" aria-label="' + escapeHtml(product.title) + '">' +
      product.variants.map(function (variant) {
        return '<option value="' + variant.id + '"' +
          (variant.id === selectedId ? ' selected' : '') + '>' +
          escapeHtml(variant.title) + '</option>';
      }).join('') +
      '</select>';
  }

  function productCard(product, extra) {
    return '<div class="sage-bundle__item">' +
      '<a class="sage-bundle__image" href="/products/' + escapeHtml(product.handle) + '">' +
      '<img src="' + escapeHtml(imageUrl(product.image)) + '" alt="' +
      escapeHtml(product.title) + '" loading="lazy" width="150" height="150"></a>' +
      extra +
      '</div>';
  }

  var CHEVRON =
    '<svg class="sage-bundle__chevron" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true">' +
    '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  // Custom list instead of a native <select>: the native popup is as wide
  // as the longest product title and runs off the side of the drawer.
  function pickerHtml(group, groupIndex, current) {
    return '<div class="sage-bundle__picker">' +
      '<button type="button" class="sage-bundle__picker-toggle" data-role="picker-toggle" ' +
      'aria-haspopup="listbox" aria-expanded="false">' +
      '<span>Pick another</span>' + CHEVRON + '</button>' +
      '<ul class="sage-bundle__picker-list" role="listbox" aria-label="Pick another" hidden>' +
      // Like Vitals, the product already shown is left out of the list.
      group.options.filter(function (product) {
        return product.id !== current.id;
      }).map(function (product) {
        return '<li role="option" aria-selected="false">' +
          '<button type="button" class="sage-bundle__picker-option" data-role="pick" ' +
          'data-group="' + groupIndex + '" data-id="' + product.id + '">' +
          '<img src="' + escapeHtml(imageUrl(product.image)) + '" alt="" loading="lazy" width="40" height="40">' +
          '<span class="sage-bundle__picker-title">' + escapeHtml(product.title) + '</span>' +
          '<span class="sage-bundle__picker-price">' + formatMoney(product.variants[0].price) + '</span>' +
          '</button></li>';
      }).join('') +
      '</ul></div>';
  }

  function detailsHtml(bundle, state, entries) {
    var fullBundle = isFullBundle(state);

    return '<details class="sage-bundle__details"' + (state.detailsOpen ? ' open' : '') + '>' +
      '<summary><span data-role="details-label">' +
      (state.detailsOpen ? 'See less' : 'See more') + '</span> ' + CHEVRON + '</summary>' +
      entries.map(function (entry, index) {
        var sale = itemSalePrice(bundle, entry.variant.price);
        var price = fullBundle && sale < entry.variant.price
          ? '<span class="sage-bundle__detail-sale">' + formatMoney(sale) + '</span> ' +
            '<s class="sage-bundle__compare">' + formatMoney(entry.variant.price) + '</s>'
          : '<span>' + formatMoney(entry.variant.price) + '</span>';

        return '<label class="sage-bundle__detail">' +
          '<input type="checkbox" data-role="toggle-item" data-index="' + index + '"' +
          (state.checked[index] ? ' checked' : '') + '>' +
          '<span class="sage-bundle__detail-info">' +
          '<a class="sage-bundle__detail-title" href="/products/' + escapeHtml(entry.product.handle) + '">' +
          escapeHtml(entry.product.title) +
          (entry.product.variants.length > 1 ? ' – ' + escapeHtml(entry.variant.title) : '') + '</a>' +
          '<span class="sage-bundle__detail-price">' + price + '</span>' +
          '</span></label>';
      }).join('') +
      '</details>';
  }

  // <details> toggles natively; remember it so a re-render keeps it open.
  function onDetailsToggle(event) {
    var details = event.target;
    var slot = event.currentTarget;

    if (!details.classList || !details.classList.contains('sage-bundle__details')) return;
    if (!slot.__sageBundle) return;

    getSelection(slot.__sageBundle).detailsOpen = details.open;

    var label = details.querySelector('[data-role="details-label"]');
    if (label) label.textContent = details.open ? 'See less' : 'See more';
  }

  function setPickerOpen(picker, open) {
    if (!picker) return;

    var toggle = picker.querySelector('[data-role="picker-toggle"]');
    var list = picker.querySelector('.sage-bundle__picker-list');

    toggle.setAttribute('aria-expanded', String(open));
    list.hidden = !open;
    picker.classList.toggle('is-open', open);
  }

  function closePickers(except) {
    document.querySelectorAll('.sage-bundle__picker.is-open').forEach(function (picker) {
      if (picker !== except) setPickerOpen(picker, false);
    });
  }

  function bundleTotals(bundle, state, entries) {
    var total = entries.reduce(function (sum, entry, index) {
      return state.checked[index] ? sum + entry.variant.price : sum;
    }, 0);
    var discounted = total;

    if (!isFullBundle(state)) {
      // Not a full bundle any more: no discount.
    } else if (bundle.discountType === 'percent') {
      // Rounded per item, like Vitals and the cart (5 x $5.53 = $27.65).
      discounted = entries.reduce(function (sum, entry) {
        return sum + Math.round(itemSalePrice(bundle, entry.variant.price) * 100) / 100;
      }, 0);
    } else if (bundle.discountType === 'fixed' || bundle.discountType === 'amount') {
      discounted = Math.max(0, total - bundle.discountAmount);
    }

    return { total: total, discounted: discounted };
  }

  function bundleHtml(bundle) {
    var state = getSelection(bundle);
    var entries = bundleEntries(bundle, state);
    var totals = bundleTotals(bundle, state, entries);
    var price = '<span class="sage-bundle__price">' + formatMoney(totals.discounted) + '</span>';

    if (totals.discounted < totals.total) {
      price += ' <s class="sage-bundle__compare">' + formatMoney(totals.total) + '</s>';
    }

    var cards = entries.map(function (entry, index) {
      var group = bundle.groups[index - 1];
      var picker = group && group.canChange && group.options.length > 1
        ? pickerHtml(group, index - 1, entry.product)
        : '';

      return productCard(entry.product, picker + variantSelect(entry.product, entry.variant.id, index));
    }).join('<span class="sage-bundle__plus" aria-hidden="true">+</span>');

    return '<div class="sage-bundle">' +
      '<p class="sage-bundle__title">' + escapeHtml(bundle.title) + '</p>' +
      '<div class="sage-bundle__products' + (entries.length > 2 ? ' sage-bundle__products--many' : '') + '">' +
      cards +
      '</div>' +
      '<p class="sage-bundle__total">Total Price: ' + price + '</p>' +
      (totals.discounted < totals.total
        ? '<p class="sage-bundle__save">You save: ' +
          formatMoney(totals.total - totals.discounted) + '</p>'
        : '') +
      '<button type="button" class="sage-bundle__button" data-role="add"' +
      (state.checked.some(Boolean) ? '' : ' disabled') + '>' +
      escapeHtml(bundle.buttonText) + '</button>' +
      '<p class="sage-bundle__error" hidden></p>' +
      detailsHtml(bundle, state, entries) +
      '</div>';
  }

  function renderBundle(slot, bundle) {
    var state = getSelection(bundle);
    var key = state.productId + ':' + state.picks.map(function (pick) {
      return pick.product + '/' + pick.variant;
    }).join(',') + ':' + state.checked.join(',');

    slot.style.display = '';

    if (slot.getAttribute('data-bundle-key') === key && slot.firstChild) return;

    slot.setAttribute('data-bundle-key', key);
    slot.innerHTML = bundleHtml(bundle);
    slot.__sageBundle = bundle;

    if (!slot.__sageBound) {
      slot.__sageBound = true;
      slot.addEventListener('change', onBundleChange);
      slot.addEventListener('click', onBundleClick);
      // "toggle" doesn't bubble, so listen in the capture phase.
      slot.addEventListener('toggle', onDetailsToggle, true);
    }

    if (!pickerListenersBound) {
      pickerListenersBound = true;

      document.addEventListener('click', function (event) {
        closePickers(event.target.closest && event.target.closest('.sage-bundle__picker'));
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closePickers(null);
      });
    }
  }

  function pickProduct(slot, groupIndex, productId) {
    var bundle = slot.__sageBundle;
    var state = getSelection(bundle);
    var product = findOption(bundle.groups[groupIndex], productId);

    state.picks[groupIndex + 1] = { product: product.id, variant: product.variants[0].id };
    renderBundle(slot, bundle);
  }

  function onBundleChange(event) {
    var slot = event.currentTarget;
    var bundle = slot.__sageBundle;
    var role = event.target.getAttribute('data-role');
    var index = Number(event.target.getAttribute('data-index'));

    if (!bundle || !role) return;

    var state = getSelection(bundle);

    if (role === 'variant') {
      state.picks[index].variant = Number(event.target.value);
    } else if (role === 'toggle-item') {
      state.checked[index] = event.target.checked;
    }

    renderBundle(slot, bundle);
  }

  function randomId(length) {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var id = '';

    for (var i = 0; i < length; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  }

  // Same payloads the Vitals widget sends: every picked item is a child
  // line of the added product, all sharing the bundle's _oid. A line can't
  // be its own parent, so picks of the added variant itself (Pearl + Pearl)
  // raise its quantity instead, and repeated picks are merged. With an item
  // unticked it's a plain add without the _oid.
  function bundleItems(state, oid) {
    var main = state.picks[0].variant;
    var full = isFullBundle(state);
    var quantities = {};
    var order = [];

    state.picks.forEach(function (pick, index) {
      if (!state.checked[index]) return;
      if (!quantities[pick.variant]) order.push(pick.variant);
      quantities[pick.variant] = (quantities[pick.variant] || 0) + 1;
    });

    if (!full) {
      return order.map(function (id) {
        return { id: id, quantity: quantities[id] };
      });
    }

    var items = order
      .filter(function (id) {
        return id !== main;
      })
      .map(function (id) {
        return { id: id, quantity: quantities[id], properties: { _oid: oid }, parent_id: main };
      });

    items.push({ id: main, quantity: quantities[main], properties: { _oid: oid } });

    return items;
  }

  function onBundleClick(event) {
    var slot = event.currentTarget;
    var toggle = event.target.closest('[data-role="picker-toggle"]');
    var option = event.target.closest('[data-role="pick"]');

    if (toggle) {
      var picker = toggle.parentNode;
      var open = !picker.classList.contains('is-open');

      closePickers(null);
      setPickerOpen(picker, open);
      return;
    }

    if (option) {
      pickProduct(
        slot,
        Number(option.getAttribute('data-group')),
        Number(option.getAttribute('data-id'))
      );
      return;
    }

    var button = event.target.closest('[data-role="add"]');

    if (!button || button.disabled) return;

    var bundle = slot.__sageBundle;
    var error = slot.querySelector('.sage-bundle__error');

    if (!bundle) return;

    var state = getSelection(bundle);
    var oid = bundle.id + '_' + randomId(10);
    var label = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (error) error.hidden = true;

    // Our own add must not switch the drawer to the bundled product.
    ownAddUntil = Date.now() + 4000;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: bundleItems(state, oid) })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            throw new Error(json.description || json.message || 'Could not add bundle');
          }
        });
      })
      .then(function () {
        return syncCart(true);
      })
      .then(refreshVitalsDrawer)
      .catch(function (err) {
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      })
      .then(function () {
        button.disabled = false;
        button.textContent = label;
      });
  }

  function updateBundleMode(drawer) {
    if (drawer && !drawerOpen) {
      cartSynced = false;
      scheduleCartSync(false);
    }

    drawerOpen = !!drawer;

    if (!drawer) return;

    var cartContent = drawer.querySelector(
      '.Vtl-CartDrawer__Container-Content'
    );

    if (!cartContent) return;

    // Wait for /cart.js so a stale product's bundle isn't shown first.
    if (!cartSynced || !cartItem || isDrawerEmpty(drawer, cartContent)) {
      hideSlot(drawer);
      return;
    }

    var productId = cartItem.productId;

    loadBundle(productId).then(function (bundle) {
      var visible = document.querySelector(VISIBLE_DRAWER);

      if (!visible || !cartItem || cartItem.productId !== productId) return;
      if (usePageWidget && !showOtherBundle) return;

      if (!bundle) {
        hideSlot(visible);
        return;
      }

      var slot = getDrawerSlot(visible);

      if (slot) renderBundle(slot, bundle);
    });
  }

  // Cart requests made by this page mean a product may have been added.
  function watchCartRequests() {
    if (!('PerformanceObserver' in window)) return;

    try {
      new PerformanceObserver(function (list) {
        var hasCartChange = list.getEntries().some(function (entry) {
          return /\/cart\/(add|change|update)/.test(entry.name);
        });

        if (hasCartChange) scheduleCartSync(Date.now() < ownAddUntil);
      }).observe({ type: 'resource' });
    } catch (e) {}
  }

  function update() {
    if (updating) return;

    updating = true;

    try {
      var drawer = document.querySelector(VISIBLE_DRAWER);

      if (!usePageWidget) {
        updateBundleMode(drawer);
      } else if (drawer && showOtherBundle) {
        restoreBundle();
        updateBundleMode(drawer);
      } else if (drawer) {
        drawerOpen = true;
        clearBuiltBundle(drawer);
        moveBundleIntoDrawer(drawer);
      } else {
        drawerOpen = false;
        restoreBundle();
      }
    } finally {
      updating = false;
    }
  }

  function init() {
    if (observer || !document.body) return;

    usePageWidget = !!(
      document.querySelector(PAGE_BUNDLE_BLOCK) ||
      document.querySelector(BUNDLE_ROOT)
    );

    if (usePageWidget) {
      pageProductId = getPageProductId();
      // Fresh snapshot so adds on this page can be told apart.
      syncCart(true);
    } else {
      readStore();
    }

    watchCartRequests();

    observer = new MutationObserver(update);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();




/* =====================================================================
   custom.js  -  ADA / WCAG fixes (The Sage Lifestyle)
   ===================================================================== */
(function () {
  'use strict';

  var LANDMARK_SEL = 'main, [role="main"], header, [role="banner"], nav, [role="navigation"], footer, [role="contentinfo"], aside, [role="complementary"], [role="region"][aria-label], [role="region"][aria-labelledby]';

  /* ---------------------------------------------------------------
     1) Vitals Instagram Feed widget -> labelled region landmark
     --------------------------------------------------------------- */
  function findCommonAncestor(a, b) {
    var node = a;
    while (node && node !== document.body) {
      if (node.contains(b)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function fixInstagramLandmark() {
    document.querySelectorAll('.Vtl-InstagramFeedWidget__Header').forEach(function (header) {
      var firstPost = document.querySelector('.Vtl-InstagramFeedLayout__Post');
      var root =
        header.closest('.Vtl-InstagramFeedWidget') ||
        (firstPost && findCommonAncestor(header, firstPost)) ||
        header.parentElement;

      if (!root || root === document.body || root === document.documentElement) return;
      if (root.getAttribute('data-ada-landmark') === 'done') return;

      if (root.closest(LANDMARK_SEL)) {
        root.setAttribute('data-ada-landmark', 'done');
        return;
      }

      var title = header.querySelector('h1, h2, h3, h4');
      root.setAttribute('role', 'region');
      if (title) {
        if (!title.id) title.id = 'vtl-insta-title-' + Math.floor(Math.random() * 100000);
        root.setAttribute('aria-labelledby', title.id);
      } else {
        root.setAttribute('aria-label', 'Instagram feed');
      }
      root.setAttribute('data-ada-landmark', 'done');
    });
  }

  /* ---------------------------------------------------------------
     2) Mobile dock: keyboard support if an item is a <div role="button">
     --------------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('.dock__item[data-action][role="button"]')) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      el.click();
    }
  });

  /* ---------------------------------------------------------------
     3) Scrollable logo slider must be keyboard focusable (safety net)
     --------------------------------------------------------------- */
  function fixScrollableRegions() {
    document.querySelectorAll('.logo-slider-track').forEach(function (track) {
      if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');
      if (!track.hasAttribute('role')) track.setAttribute('role', 'region');
      if (!track.hasAttribute('aria-label') && !track.hasAttribute('aria-labelledby')) {
        track.setAttribute('aria-label', 'Logo slider');
      }
    });
  }

  /* ---------------------------------------------------------------
     4) Wizybot chat widget (3rd-party)
        - iframe never gets a role (invalid on <iframe>)
        - "!" badge is decorative -> aria-hidden
        - the widget's top-level wrapper (direct child of <body>) becomes a
          labelled landmark, so badge + iframe + chat button are all inside it
        - works across open shadow roots
     --------------------------------------------------------------- */
  var WZ_SEL = '#WizybotShopifyWidget__iframe__outter__id, .WizybotShopifyWidget__open__button__notification';

  function deepQueryAll(selector) {
    var found = Array.prototype.slice.call(document.querySelectorAll(selector));
    document.querySelectorAll('[id*="izybot" i], [class*="izybot" i]').forEach(function (host) {
      if (host.shadowRoot) {
        host.shadowRoot.querySelectorAll(selector).forEach(function (el) { found.push(el); });
      }
    });
    return found;
  }

  // climb to the element that is a direct child of <body>, crossing shadow roots
  function topLevelWrapper(node) {
    var cur = node;
    for (var i = 0; i < 50; i++) {
      var p = cur.parentElement;
      if (!p) {
        var root = cur.getRootNode && cur.getRootNode();
        if (root && root.host) { cur = root.host; continue; }
        return null;
      }
      if (p === document.body) return cur;
      cur = p;
    }
    return null;
  }

  function fixChatWidgetLandmark() {
    deepQueryAll(WZ_SEL).forEach(function (node) {
      var isIframe = node.tagName === 'IFRAME';
      var isBadge  = node.classList.contains('WizybotShopifyWidget__open__button__notification');

      if (isIframe) {
        node.removeAttribute('role');
        node.removeAttribute('aria-label');
      }
      if (isBadge && node.getAttribute('aria-hidden') !== 'true') {
        node.setAttribute('aria-hidden', 'true');
      }
      if (node.closest(LANDMARK_SEL)) return;

      var top = topLevelWrapper(node);
      if (!top) return;

      var topIsSelf = (top === node);
      var canLabelTop =
        !topIsSelf &&
        top.tagName !== 'IFRAME' &&
        !top.getAttribute('role') &&
        !top.querySelector('main, header, footer, [role="main"]');

      if (canLabelTop) {
        if (top.getAttribute('data-ada-landmark') === 'done') return;
        top.setAttribute('role', 'complementary');
        top.setAttribute('aria-label', 'Chat assistant');
        top.setAttribute('data-ada-landmark', 'done');
        return;
      }

      // fallback: wrap the badge itself (never the iframe, moving it would reload the chat)
      if (isBadge && node.parentElement && !node.parentElement.hasAttribute('data-ada-wrap')) {
        var wrap = document.createElement('div');
        wrap.setAttribute('data-ada-wrap', '');
        wrap.setAttribute('role', 'complementary');
        wrap.setAttribute('aria-label', 'Chat assistant');
        wrap.style.display = 'contents';
        node.parentElement.insertBefore(wrap, node);
        wrap.appendChild(node);
      }
    });
  }

  /* ---------------------------------------------------------------
     5) Header cart <summary>: nothing focusable/clickable inside it
     --------------------------------------------------------------- */
  function fixCartSummary() {
    document.querySelectorAll('summary[aria-label="View cart"]').forEach(function (summary) {
      if (summary.getAttribute('role') === 'button') summary.removeAttribute('role');
      Array.prototype.forEach.call(summary.children, function (child) {
        if (!child.hasAttribute('inert')) child.setAttribute('inert', '');
      });
      summary.querySelectorAll('svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
      });
    });
  }

  /* ---------------------------------------------------------------
     Run now + whenever apps / cart refresh inject or re-render markup
     --------------------------------------------------------------- */
  function runAll() {
    fixInstagramLandmark();
    fixScrollableRegions();
    fixChatWidgetLandmark();
    fixCartSummary();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      runAll();
    });
  }

  function init() {
    runAll();
    if ('MutationObserver' in window) {
      // kept running: the Wizybot badge appears late and is re-created
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('cart:refresh', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();




(function () {
  function fixDuplicateSvgTitleIds() {
    var seenIds = new Set();

    document.querySelectorAll('svg title[id]').forEach(function (title) {
      var id = title.id;

      if (seenIds.has(id)) {
        title.remove();
      } else {
        seenIds.add(id);
      }
    });
  }

  fixDuplicateSvgTitleIds();

  new MutationObserver(fixDuplicateSvgTitleIds).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();


// FOR PDP PAGE ADA ISSUES

// ===== ADA contrast fixes (Vtl app + fragrance notes) =====
(function () {
  var FIXES = [
    // selector, color, contrast on its background
    { sel: '.Vtl-ProductLabel__Text',                color: '#3F7658' }, // 5.33:1 on #fff
    { sel: '.Vtl-BundleSummary__OriginalPrice',      color: '#6b6b6b' }, // 5.33:1 on #fff
    { sel: '.Vtl-AiReviewSummary__label',            color: '#7a6030' }, // 5.68:1 on #fff9f4
    { sel: '.Vtl-AiReviewSummary__label-subtext',    color: '#6b6766' }, // 5.35:1 on #fff9f4
    { sel: '[class^="ai-fragrance-notes__tier-label-"]', color: '#4a6d5a' } // 5.55:1 on #fafafa
  ];

  function fixEl(el, color) {
    if (el.getAttribute('data-ada-done') === color) return;
    el.style.setProperty('color', color, 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.setAttribute('data-ada-done', color);
  }

  function run(root) {
    if (!root || root.nodeType !== 1) return;
    FIXES.forEach(function (f) {
      if (root.matches && root.matches(f.sel)) fixEl(root, f.color);
      root.querySelectorAll(f.sel).forEach(function (el) { fixEl(el, f.color); });
    });
  }

  function start() {
    run(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(run);
        // app re-styles an existing element: re-apply
        if (m.type === 'attributes' && m.target.hasAttribute('data-ada-done')) {
          var f = FIXES.find(function (x) { return m.target.matches(x.sel); });
          if (f) { m.target.removeAttribute('data-ada-done'); fixEl(m.target, f.color); }
        }
      });
    }).observe(document.body, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class']
    });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




(function () {
  'use strict';

  var selector = '.vtl-pr-stats__bar-item[role="button"]';

  function fixRatingLabels(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches(selector)) {
      root.removeAttribute('aria-label');
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.removeAttribute('aria-label');
      });
    }
  }

  // Fix elements already present
  fixRatingLabels(document);

  // Handle Vitals elements added or updated dynamically
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          fixRatingLabels(node);
        });
      }

      if (
        mutation.type === 'attributes' &&
        mutation.target.matches(selector)
      ) {
        mutation.target.removeAttribute('aria-label');
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
})();



// for contact page ada 

/* Accessibility Fix: Duplicate Store Locator IDs */
(function () {
  'use strict';


  function fixDuplicateStoreLocatorIds() {
    var elements = document.querySelectorAll(
      '[id="scapl-geocode-btn"]'
    );

    elements.forEach(function (element, index) {
      if (index > 0) {
        element.id = 'scapl-geocode-btn-' + index;
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDuplicateStoreLocatorIds);
  } else {
    fixDuplicateStoreLocatorIds();
  }

  // Detect dynamically added app elements
  var observer = new MutationObserver(function () {
    fixDuplicateStoreLocatorIds();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();